/**
 * nat模块接口列表
 */
 import $http from '../utils/http'; // 导入http中创建的axios实例

 const nat = {
    //分页查询nat网关接口
    pageNat(params) {
        return $http.post(`${global.API_URL}/sme/resourceNatgateway/page`,params);
      },
    //删除
    deleteNat(id ,params) {
      let param = new URLSearchParams();
      param.append(id, params);
      return $http.post(`${global.API_URL}/sme/resourceNatgateway/delete`,param);
    },
    //nat网关详情
    queryNatGatewayByNatGatewayId(params) {
    return $http.post(`${global.API_URL}/sme/resourceNatgateway/queryNatGatewayByNatGatewayId`,params);
  },
  //查询当前模块下所有cloudWatch指标
  checkALINatGatewayIndex(params){
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkALINatGatewayIndex`,params);
  }
 }
 
 export default nat;
 


// WEBPACK FOOTER //
// ./src/api/nat.js